import * as React from 'react';
import styled from 'styled-components';

import { INTERNAL_LINKS, SIGNUP_LINK } from '../../utils';
import { Button, GradientHeader, Text } from '../design-system';
import { ToutWrapper } from '../design-system/ToutWrapper';

const Inner = styled.div`
  display: flex;
  border-top: 1px dashed ${({ theme }) => theme.borderColor.MUTED};
  border-bottom: 1px dashed ${({ theme }) => theme.borderColor.MUTED};
`;

const Content = styled.div`
  display: flex;
  max-width: calc(${({ theme }) => theme.maxWidth.PAGE} - 300px);
  margin: 0 auto;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    flex-direction: column;
  }
`;

const Column = styled.div`
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 60px 40px 40px;
`;

const Left = styled(Column)`
  flex-grow: 2;
`;

const Right = styled(Column)`
  border-left: 1px dashed ${({ theme }) => theme.borderColor.MUTED};

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    border-left: none;
    border-top: 1px dashed ${({ theme }) => theme.borderColor.MUTED};
  }
`;

const StyledHeading = styled(GradientHeader).attrs({
  $purple: true,
  renderAs: 'h3'
})`
  && {
    text-align: left;
    margin-bottom: 10px;
    padding: 0;
  }
`;

const Actions = styled.div`
  display: flex;
  gap: 20px;
`;

export const BottomCTATout: React.ComponentType = React.memo(() => {
  return (
    <ToutWrapper>
      <Inner>
        <Content>
          <Left>
            <StyledHeading renderAs="h3">
              Getting started is easy.
            </StyledHeading>
            <Text size="large">
              Connect Hex to your data warehouse and do more with it
              immediately.
            </Text>
            <Actions>
              <Button
                link={`${SIGNUP_LINK}?source=bottom-cta`}
                stylez="loud"
                text="Get started for free"
              />
              <Button link={INTERNAL_LINKS.ContactUs} text="Talk to us" />
            </Actions>
          </Left>
          <Right>
            <Text size="medium">
              Check out all of our plans to fit your team or organization.
            </Text>
            <Button link={INTERNAL_LINKS.Pricing} text="See our plans" />
          </Right>
        </Content>
      </Inner>
    </ToutWrapper>
  );
});
